import { probeMediaDuration } from './mediaProbe';

export const getAudioLength = async (file) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('Missing audio file'));
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    const audio = new Audio(objectUrl);
    let handled = false;

    const cleanup = () => {
      URL.revokeObjectURL(objectUrl);
    };

    const fallbackToFFmpeg = async () => {
      if (handled) return;
      handled = true;
      cleanup();
      try {
        resolve(await probeMediaDuration(file));
      } catch (error) {
        reject(error);
      }
    };

    audio.onloadedmetadata = function() {
      const duration = audio.duration;
      if (!Number.isFinite(duration) || duration <= 0) {
        void fallbackToFFmpeg();
        return;
      }
      if (handled) return;
      handled = true;
      cleanup();
      resolve(duration);
    };

    audio.onerror = function() {
      void fallbackToFFmpeg();
    };
  });
};
